/* global $:true module:true */

import debug from "debug";
import { onAvailable } from '@core/plugins/lib/selectors';
import modaal from './modaal';

const ELEMENT_SELECTOR = '[data-open-modaal],[data-modaal-swiper],[data-opened-modaal]';
const MODULE_NAME = 'core/modules/modaal';
const log = debug(MODULE_NAME);

export function exec () {
	onAvailable.ready(ELEMENT_SELECTOR, function(element) {
		modaal();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/modaal/index.js